module.exports = __webpack_public_path__ + "img/informacion.91a35dcc.svg";